import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi } from "../../../service";

// export const createNewCategory = async (body) =>
//   hneAdminApi.post(`${ApiRoutes.CREATE_CATEGORY}`, body);

// export const getAllCategory = async (body) =>
//   hneAdminApi.get(`${ApiRoutes.CREATE_CATEGORY}`, body);

export const getNewsById = async (news_id, language) =>
  hneAdminApi.get(`${ApiRoutes.GET_NEWS}/${news_id}?language=${language}`);

export const getNewsByTags = async (language, id_list) =>
  hneAdminApi.post(`${ApiRoutes.GET_NEWS_BY_TAGS}/${language}`, id_list);

export const getJobsByTags = async (id_list) =>
  hneAdminApi.post(`${ApiRoutes.GET_JOBS_BY_TAGS}`, id_list);

export const getTrendingNewsByCategory = async (
  type,
  period,
  year,
  language,
  noOfNews
) =>
  hneAdminApi.get(
    `${ApiRoutes.GET_TRENDING_NEWS}/${type}/${period}/${year}/${language}/${noOfNews}`
  );

export const getNextNewsById = async (language, news_id, action) =>
  hneAdminApi.get(
    `${ApiRoutes.GET_NEXT_NEWS}/${language}/${news_id}/${action}`
  );
